export default __webpack_public_path__ + "8e7fa07dd6075a0aeba046f79c18ff2e.svg";